var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.37 18.984 32.768 3.785c-1.54-1.33-3.969-.25-3.969 1.817v8.005C12.737 13.79 0 17.01 0 32.233c0 6.144 3.958 12.23 8.333 15.413 1.366.993 3.311-.253 2.808-1.863C6.607 31.28 13.291 27.432 28.8 27.209V36c0 2.07 2.43 3.145 3.969 1.816l17.6-15.2a2.4 2.4 0 0 0 0-3.632"
  })));
};
export default SvgShare;